import axios from "@/api/axiosInstance";
import { SaveCoachResponsesResponse } from "./types";
import type {
  CoachAttemptDetail,
  SaveCoachResponsesPayload,
} from "../../types/diagnostic";

/**
 * Replace an in-progress attempt's answers. There is no autosave — every call
 * is an explicit button press.
 *
 * `trades` is optional on the payload and the distinction is load-bearing:
 * omitting the key leaves the stored selection alone, `[]` clears it.
 */
export const saveCoachResponses = async (
  attemptId: number,
  payload: SaveCoachResponsesPayload,
): Promise<CoachAttemptDetail> => {
  const response = await axios.put<SaveCoachResponsesResponse>(
    `/api/private/attempts/${attemptId}/responses`,
    payload,
  );
  return response.data.data;
};
